const BASE = 'https://script.google.com/macros/s/AKfycbxQM5f8aSQv5Whm8AB5l56G5Vcgkzbz_-vvy4U1viOoZ_ev6CntqTLT3OuWSevBf77O/exec';
const TTL = 10 * 60 * 1000; // 10min

async function loadSiteResources(lang, { nocache=false } = {}) {
  const key = 'site_all_' + lang;
  if (!nocache) {
    try {
      const raw = localStorage.getItem(key);
      if (raw) {
        const { ts, data } = JSON.parse(raw);
        if (Date.now() - ts < TTL) return data;
      }
    } catch(e){}
  }


  const url = `${BASE}?page=all&lang=${encodeURIComponent(lang)}${nocache ? '&nocache=1' : ''}&ts=${Date.now()}`;
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error('Network response not ok');
    const data = await res.json();
    try { localStorage.setItem(key, JSON.stringify({ ts: Date.now(), data })); } catch(e){}
    return data;
  } catch (err) {
    
    try {
      const data = await fetchJsonp(url);
      try { localStorage.setItem(key, JSON.stringify({ ts: Date.now(), data })); } catch(e){}
      return data;
    } catch (err2) {
      console.error('loadSiteResources failed', err, err2);
      return null;
    }
  }
}


function fetchJsonp(url) {
  return new Promise((resolve, reject) => {
    const cb = 'jsonp_cb_' + Date.now() + '_' + Math.floor(Math.random()*10000);
    window[cb] = (data) => { cleanup(); resolve(data); };
    const cleanup = () => {
      try { delete window[cb]; } catch(e) {}
      script.remove();
    };
    const script = document.createElement('script');
    script.src = url + (url.includes('?') ? '&' : '?') + 'callback=' + cb;
    script.onerror = () => { cleanup(); reject(new Error('JSONP load error')); };
    document.body.appendChild(script);
  });
}


export async function fetchAllForLang(lang = 'fi') {
  return loadSiteResources(lang, { nocache: false });
}


export async function fetchPageContent(page, lang = 'fi') {
  try {
    const all = await loadSiteResources(lang, { nocache: false });
    if (all && all[page]) return all[page];
  } catch (e) {
  }

  
  try {
    const res = await fetch(`${BASE}?page=${encodeURIComponent(page)}&lang=${encodeURIComponent(lang)}&ts=${Date.now()}`);
    if (!res.ok) throw new Error('Network error');
    const data = await res.json();
    return data;
  } catch (err) {
    console.error('fetchPageContent error:', err);
    return null;
  }
}

const contentApi = { loadSiteResources, fetchAllForLang, fetchPageContent };

export default contentApi;